import React from 'react'
import LoginCompo from '../components/Login/LoginCompo'

const Login = () => {
  return (
    <>
        <LoginCompo/> 
 
    </>
  )
}

export default Login